import { ArticlesTable } from "@/components/stock/articles-table";
import { useWarehouseLocations } from "@/hooks/use-warehouse-locations";
import { DataTable, type DataTableProps } from "@msuite/ui/table";
import type { GetWarehouseLocationsQuerySchema } from "@msuite/utils/schemas";
import type { Nullable } from "@msuite/utils/types";
import type React from "react";
import { articleWarehouseLocationColumns, columns } from "./table-config";

/** Props Interface */
interface WarehouseLocationsProps {
	query: GetWarehouseLocationsQuerySchema;
	menu?: Nullable<React.ReactNode>;
	variant?: DataTableProps<any>["variant"];
}

export function WarehouseLocations({ query, menu = null, variant }: WarehouseLocationsProps) {
	/** Hooks */
	const { warehouseLocations, isLoading, queryKey, refetch } = useWarehouseLocations(query);

	/** Computed */
	// The article's own balance per shelf is the point of the list when one article is named, and
	// the server leaves that column null in every other case. A list narrowed to an article also
	// expands into nothing: what sits under a shelf is the articles on it, and the article is the
	// row above.
	const isNarrowedToArticle = Boolean(query?.articleId);

	/** Render */
	return (
		<DataTable
			variant={variant}
			data={warehouseLocations}
			columns={isNarrowedToArticle ? articleWarehouseLocationColumns : columns}
			persistenceKey={
				isNarrowedToArticle ? "article-warehouse-locations-table" : "warehouse-locations-table"
			}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={menu}
			getRowCanExpand={() => !isNarrowedToArticle}
			renderSubRows={(row) => (
				<ArticlesTable
					variant="sub-table"
					query={{ warehouseLocationId: row.original.id }}
				/>
			)}
		/>
	);
}
